import { ChipProps } from '@mui/material';
import { PaymentFrequencyType } from '@schooly/api';
import { TagSelect } from '@schooly/style';
import { FC } from 'react';
import { useIntl } from 'react-intl';

export type FrequencyTagSelectProps = {
  type: PaymentFrequencyType;
} & Omit<ChipProps, 'label'>;

export const FrequencyTagSelect: FC<FrequencyTagSelectProps> = ({ type, ...props }) => {
  const { $t } = useIntl();

  return <TagSelect label={$t({ id: `frequencies-${type}` })} {...props} />;
};
